import { render, staticRenderFns } from "./SuspiciousActivityName.vue?vue&type=template&id=eb540f32&"
import script from "./SuspiciousActivityName.vue?vue&type=script&lang=js&"
export * from "./SuspiciousActivityName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SuspiciousActivityName.vue"
export default component.exports